import 'theme';

// Use Impact's documented lightbox event and the native PhotoSwipe instance.
const labelledGalleries = new WeakSet();
document.addEventListener('lightbox:open', event => {
  const gallery = event.target.closest?.('product-gallery');
  const root = gallery?.closest('[data-cp-product]');
  if (!root || labelledGalleries.has(gallery)) return;
  labelledGalleries.add(gallery);
  gallery.photoswipe.on('afterInit', () => {
    const element = gallery.photoswipe.pswp?.element;
    element?.querySelector('[rel="prev"]')?.setAttribute('aria-label', root.dataset.cpPreviousPhoto);
    element?.querySelector('[rel="next"]')?.setAttribute('aria-label', root.dataset.cpNextPhoto);
  });
}, {capture: true});
